// extracted by mini-css-extract-plugin
export default {"box":"carroFicha_box__OV0v3","navbarScrollCustom":"carroFicha_navbarScrollCustom__lkKWg","rectangle":"carroFicha_rectangle__K45P8"};